// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"482":"charts","824":"portfolio"}[chunkId] || chunkId) + "." + {"17":"06a2518b","74":"bdae4967","134":"68f92968","180":"e4da614e","329":"f6c2ef21","447":"4822fa93","448":"4e1bc40d","482":"4279b507","761":"2e592e0f","819":"c5984e54","824":"d65547a0","927":"8b17cc39","951":"70a52edd"}[chunkId] + ".js";
};